(function () {
  var productCache = {};
  var inflight = null;
  var queued = false;
  var mutating = false;

  function isGift(item) {
    return item && item.product_type === 'Gift';
  }

  function isPaid(item) {
    if (!item || isGift(item)) return false;
    var type = item.product_type;
    return type !== 'Fee' && type !== 'Fee Placeholder';
  }

  function itemQualifies(item, promo) {
    if (!item || !promo) return false;
    if (promo.min && item.price < promo.min) return false;
    if (promo.collection) {
      if ((item.collections || []).indexOf(promo.collection) < 0) return false;
    } else if (promo.type && item.product_type !== promo.type) {
      return false;
    }
    if (promo.noDiscount) {
      if (item.compare_at_price > item.price) return false;
      var discounts = item.line_level_discount_allocations;
      if (discounts && discounts.some(function (row) { return row.amount > 0; })) return false;
    }
    return true;
  }

  function cartPath(url) {
    if (!url) return '';
    var path = String(url).split('?')[0];
    var origin = window.location.origin;
    if (path.indexOf(origin) === 0) path = path.slice(origin.length);
    return path;
  }

  function isCartMutateUrl(url) {
    return /\/cart\/(add|change|update|clear)\.js$/.test(cartPath(url));
  }

  function parseBody(data) {
    if (!data) return null;
    if (typeof data === 'object') return data;
    if (typeof data !== 'string') return null;
    try {
      return JSON.parse(data);
    } catch (e) {
      return null;
    }
  }

  function isAttributesOnly(data) {
    var obj = parseBody(data);
    if (!obj || !obj.attributes) return false;
    return obj.updates == null && obj.id == null && obj.quantity == null && !obj.items;
  }

  function fetchJson(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, opts || {})).then(function (res) {
      if (!res.ok) throw new Error(url + ' ' + res.status);
      return res.json();
    });
  }

  function getCart() {
    return fetchJson('/cart.js');
  }

  function cartPost(url, body) {
    mutating = true;
    return fetchJson(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).finally(function () {
      mutating = false;
    });
  }

  function enrichItem(item) {
    var variantId = item.variant_id || item.id || '';
    var cacheKey = item.handle + ':' + variantId;
    if (productCache[cacheKey]) {
      return Promise.resolve(Object.assign({}, item, productCache[cacheKey]));
    }
    var url = '/products/' + item.handle + '?view=gwp';
    if (variantId) url += '&variant=' + variantId;
    return fetchJson(url).then(function (data) {
      var extra = {
        collections: data.collections || [],
        compare_at_price: data.compare_at_price || item.price,
        product_type: item.product_type || data.type || ''
      };
      productCache[cacheKey] = extra;
      return Object.assign({}, item, extra);
    }).catch(function () {
      return Object.assign({}, item, {
        collections: [],
        compare_at_price: item.price
      });
    });
  }

  function resolveVariantId(promo) {
    if (promo.variantId) return Promise.resolve(promo.variantId);
    if (!promo.gift) return Promise.resolve(0);
    return fetchJson('/products/' + promo.gift + '.js').then(function (product) {
      var id = product.variants && product.variants[0] && product.variants[0].id;
      promo.variantId = id || 0;
      return promo.variantId;
    }).catch(function () {
      return 0;
    });
  }

  function bestPromoForItem(item, promos) {
    var best = null;
    (promos || []).forEach(function (promo) {
      if (!promo.gift || !itemQualifies(item, promo)) return;
      if (!best || (promo.min || 0) > (best.min || 0)) best = promo;
    });
    return best;
  }

  function applyNoCombine(list) {
    if (!list || list.length < 2) return list || [];
    var stackable = list.filter(function (promo) { return !promo.noCombine; });
    var exclusive = list.filter(function (promo) { return promo.noCombine; });
    if (stackable.length && exclusive.length) return stackable;
    if (!stackable.length && exclusive.length > 1) {
      exclusive.sort(function (a, b) { return (b.min || 0) - (a.min || 0); });
      return [exclusive[0]];
    }
    return list;
  }

  function desiredPromos(paid, promos) {
    var seen = {};
    var list = [];
    (paid || []).forEach(function (item) {
      var promo = bestPromoForItem(item, promos);
      if (!promo || seen[promo.gift]) return;
      seen[promo.gift] = true;
      list.push(promo);
    });
    return applyNoCombine(list);
  }

  function runOps(ops) {
    return ops.reduce(function (chain, op) {
      return chain.then(function () {
        if (op.type === 'remove' || op.type === 'qty') {
          return cartPost('/cart/change.js', { id: op.item.key, quantity: op.quantity });
        }
        if (op.type === 'add') {
          return resolveVariantId(op.promo).then(function (id) {
            if (!id) return;
            return cartPost('/cart/add.js', {
              items: [{ id: id, quantity: 1 }]
            }).catch(function () {});
          });
        }
      });
    }, Promise.resolve());
  }

  function doSync() {
    var promos = window.themeGwpPromos || [];
    return getCart().then(function (cart) {
      var items = cart.items || [];
      var paid = items.filter(isPaid);
      var gifts = items.filter(isGift);

      if (!paid.length) {
        if (!gifts.length) return false;
        return runOps(gifts.map(function (item) {
          return { type: 'remove', item: item, quantity: 0 };
        })).then(function () { return true; });
      }

      return Promise.all(paid.map(enrichItem)).then(function (enriched) {
        var want = desiredPromos(enriched, promos);
        var wantHandles = {};
        want.forEach(function (promo) {
          wantHandles[promo.gift] = promo;
        });

        var ops = [];
        var kept = {};

        gifts.forEach(function (gift) {
          if (!wantHandles[gift.handle] || kept[gift.handle]) {
            ops.push({ type: 'remove', item: gift, quantity: 0 });
            return;
          }
          kept[gift.handle] = true;
          if (gift.quantity !== 1) {
            ops.push({ type: 'qty', item: gift, quantity: 1 });
          }
        });

        want.forEach(function (promo) {
          if (kept[promo.gift]) return;
          ops.push({ type: 'add', promo: promo });
          kept[promo.gift] = true;
        });

        if (!ops.length) return false;
        return runOps(ops).then(function () { return true; });
      });
    });
  }

  function emitUpdated(changed) {
    var detail = { changed: !!changed };
    document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: detail }));
    if (window.jQuery) window.jQuery(document).trigger('theme:cart:updated', [detail]);
  }

  function sync(hadChange) {
    if (inflight) {
      queued = true;
      return inflight;
    }
    inflight = doSync().then(function (changed) {
      var any = !!hadChange || !!changed;
      inflight = null;
      if (queued) {
        queued = false;
        return sync(any);
      }
      emitUpdated(any);
      return any;
    }).catch(function (err) {
      inflight = null;
      console.error('GWP sync failed:', err);
      if (queued) {
        queued = false;
        return sync(hadChange);
      }
    });
    return inflight;
  }

  function afterCartSuccess() {
    if (mutating) return;
    sync();
  }

  function wrapJquery() {
    if (!window.jQuery || window.jQuery.gwpCartHooked) return;
    window.jQuery.gwpCartHooked = true;
    window.jQuery(document).ajaxComplete(function (event, xhr, settings) {
      if (mutating || !settings || !isCartMutateUrl(settings.url)) return;
      if (isAttributesOnly(settings.data)) return;
      if (xhr && xhr.status >= 400) return;
      afterCartSuccess();
    });
  }

  if (window.jQuery) wrapJquery();
  else document.addEventListener('DOMContentLoaded', wrapJquery);

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var promise = nativeFetch.apply(this, arguments);
      if (mutating || method === 'GET' || !isCartMutateUrl(url)) return promise;
      var body = init && init.body;
      if (isAttributesOnly(body)) return promise;
      return promise.then(function (res) {
        if (res && res.ok) afterCartSuccess();
        return res;
      });
    };
  }

  window.themeGwpSync = sync;
  window.themeSyncGwpEligibility = sync;
  window.themeGwpItemQualifies = itemQualifies;
})();
